import React from 'react';
// import Header from './components/Header/Header';
import AppRouter from './components/AppRouter';

import './styles/global.scss';

function App() {
  return (
    <div className="App">
      <AppRouter/>
    </div>
  );
}

export default App;